import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/lib/auth";
import { Skeleton, SkeletonPanel } from "@/components/ui/skeleton";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, refresh } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div role="status" className="h-full bg-background p-6 space-y-6">
        <Skeleton className="h-8 w-24" />
        <p className="text-sm text-muted-foreground">Opening your workspace…</p>
        <SkeletonPanel className="h-64" />
      </div>
    );
  }

  if (status === "error") return <div role="alert" className="p-6 space-y-3">
    <p>Could not verify your session. Check your connection and try again.</p>
    <button className="underline" onClick={() => void refresh()}>Try again</button>
  </div>;

  if (status === "anon") {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
